<template>
  <div class="fixed flex h-full w-full items-center justify-center bg-gray-50">
    <LogoAnimated class="h-20 w-20" />
  </div>
</template>
